import React from "react";
import { createContext, useContext, useState } from "react";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [name, setName] = useState(() => {
    const stored = localStorage.getItem("name");
    if (!stored) return null;

    // "admin" → admin
    if (
      stored.length >= 2 &&
      stored.startsWith('"') &&
      stored.endsWith('"')
    ) {
      return stored.slice(1, -1);
    }

    return stored;
  });



  const updateUserName = (newName) => {
    setName(newName);
    localStorage.setItem("name", JSON.stringify(newName));
  };

  return (
    <AuthContext.Provider value={{ name, updateUserName }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
};
